module.exports = __webpack_public_path__ + "media/images/lb/954-d108d920ab1f96328f9834bd8f2a1c91.svg";